<modal-search-filter-item [title]="model.label" (save)="Save($event)" (close)="Close($event)" [processing]="processing" [modalMode]="modalMode">
  <div class="form-group">
    <input #txt="ngModel" type="text" id="txt" name="txt" [pattern]="model.regex?.source" class="font-reg form-control form-control-lg input-blue-border" [placeholder]="model.placeholder" [(ngModel)]="model.value" (keyup.enter)="Save($event)" (keypress)="keyPress($event)">

    <div *ngIf="txt.invalid && (txt.dirty || txt.touched)" class="text-white">
      <div *ngIf="txt.errors?.pattern">
        <p class="has-error text-red mb-0">
          {{model.regexError}}
        </p>
      </div>
    </div>
  </div>
</modal-search-filter-item>
